var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.atual)?_c('v-img',{staticClass:"img",attrs:{"src":this.atual.metadata.poster,"contain":"","aspect-ratio":16 / 9}}):_c('v-icon',{attrs:{"size":"50"}},[_vm._v(" ri-shield-user-line ")])}
var staticRenderFns = []

export { render, staticRenderFns }